import { styled } from '@mui/material';

export const FormRoot = styled('form')(() => ({
  width: '100%',
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  overflowY: 'auto',
  overflowX: 'hidden',
  paddingBottom: 20,
  marginTop: 20,
  scrollbarWidth: 'thin',
  '&::-webkit-scrollbar': {
    width: 8,
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(0, 0, 0, 0.24)',
    borderRadius: 999,
  },
}));
